import { render, staticRenderFns } from "./Postcode.vue?vue&type=template&id=7962dee8&scoped=true&lang=pug"
import script from "./Postcode.vue?vue&type=script&lang=ts"
export * from "./Postcode.vue?vue&type=script&lang=ts"
import style0 from "./Postcode.vue?vue&type=style&index=0&id=7962dee8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7962dee8",
  null
  
)

/* custom blocks */
import block0 from "./Postcode.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FQuestionnaire%2Fcomponents%2FAnswerBlocks%2Fcomponents%2FPostcode.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports